export default "__VITE_ASSET__Buh99yhO__"